import _ from 'underscore';
import React from 'react';

import Container from 'components/Container';
import ReviewCard from 'components/cards/ReviewCard';
import Section from 'components/Section';
import SizeDependedBlock from 'components/SizeDependedBlock';
import SlideSection from 'components/SlideSection';
import { Grid, Block, Row } from 'components/Grid';

import CommonPropTypes from 'utils/propTypes/common';

const Reviews = ({ publications, promoBlocks }) => {
	const reviews = publications.concat(promoBlocks);

	return (
		<SizeDependedBlock>
			<SlideSection
				title="Обзоры"
				items={reviews}
				markupBlocks={{ section: { 'data-reviews': 'all' } }}
			>
				{_(reviews).map((review) => (
					<ReviewCard key={review._id} data={review} withButton />
				))}
			</SlideSection>
			<Section
				title="Обзоры"
				markupBlocks={{ section: { 'data-reviews': 'all' } }}
			>
				<Container>
					<Grid>
						<Row>
							<div>
								<Block orientation="landscape">
									<ReviewCard data={publications[0]} size="fill" />
								</Block>
								<Block orientation="landscape">
									<ReviewCard data={publications[1]} size="fill" />
								</Block>
							</div>
							<div>
								<Block orientation="landscape">
									<ReviewCard data={publications[2]} size="fill" />
								</Block>
								<Block orientation="landscape">
									<ReviewCard data={publications[3]} size="fill" />
								</Block>
							</div>
							<div>
								<Block orientation="portrait">
									<ReviewCard data={promoBlocks[0]} size="fill" />
								</Block>
							</div>
						</Row>
					</Grid>
				</Container>
			</Section>
		</SizeDependedBlock>
	);
};

Reviews.propTypes = {
	publications: CommonPropTypes.entities.isRequired,
	promoBlocks: CommonPropTypes.entities.isRequired
};

export default Reviews;
